module.exports = "/fonts/vendor/quasar-extras/roboto-web-KFOlCnqEu92Fr1MmYUtfBBc-.woff?8c2ade503b34e31430d6c98aa29a52a3";


//////////////////
// WEBPACK FOOTER
// ./node_modules/quasar-extras/roboto-font/web-font/KFOlCnqEu92Fr1MmYUtfBBc-.woff
// module id = YW6h
// module chunks = 49